import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";

import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const USER_SHOW = "user/show";
export const showUser = createAsyncThunk(USER_SHOW, async (thunkAPI) => {
  try {
    const user = new DataSource({
      store: new ODataStore({
        url: `${baseUrl}User`,
        key: "Oid",
        version: 4,
        beforeSend: (request) => {
          request.headers["token"] = token;
          request.headers["MappedState"] = 1;
        },
      }),
      expand: ["Employee($expand=Department,Position)"],
    });
    return user
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

